<template>
  <div>
    <div class="row-tb-head" style="margin-top: 10px">
      <span>加工信息</span>
    </div>
    <el-table
      ref="table"
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      border
    >
      <el-table-column
        prop="ProductNo"
        label="加工后存货编码"
        min-width="160"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ProductName"
        label="加工后存货名称"
        min-width="160"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="110" align="center">
      </el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="110" align="center">
      </el-table-column>
      <el-table-column
          prop="ColorName"
          label="颜色"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column
          prop="PdUnitName"
          label="单位"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column
        prop="Quantity"
        label="需求数量"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" min-width="110" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{row.ProductId ? '查看' : ''}}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="Remarks"
        label="备注"
        min-width="110"
        align="center"
      >
      </el-table-column>
    </el-table>

    <div  v-for="(item, index) in detailData" :key="index">
         <div class="row-tb-head" style="margin-top: 10px">
      <span>{{item.name}}子件信息</span>
    </div>
    <el-table
      ref="sub_table"
      class="table_bottom table-line tb-c-head"
      :data="item.DetailModels"
      border
    >
      <el-table-column
        prop="ProductNo"
        label="加工前存货编码"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="ProductName"
        label="加工前存货名称"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="Model" label="规格" min-width="110" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.ProductSpec }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="PropertyName" label="加工前属性" min-width="110" align="center">
      </el-table-column>
      <el-table-column
          prop="ColorName"
          label="加工前颜色"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column
          prop="PdUnitName"
          label="单位"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column
        prop="Quantity"
        label="需求数量"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" min-width="110" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{row.ProductId ? '查看' : ''}}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="Remarks"
        label="备注"
        min-width="110"
        align="center"
      >
      </el-table-column>
    </el-table>

    </div>
    <come-list-dialog @select="comeSelect" ref="comeListDialog" in-dialog />
   <img-dialog ref="imgDialog" :imgs="imgs" />

  </div>
</template>

<script>
import accountSelect from '@/components/production/clothmanagement/cloth/select'
import comeListDialog from "@/components/basedata/business/come/listDialog";
import imgDialog from './imgDialog'
import { urlHttp } from './bomConfig'



export default {
  name: "wjSpecial",
  components: {
    accountSelect,
    comeListDialog,
    imgDialog
  },
  props: {
    special: {
      type: Array,
      default: () => []
    },
    productData: {
      type: Array,
      default: () => []
    },
    processListProp: {
      type: Array,
      default: () => []
    }
    
  },
  watch: {
    special(data){

      console.log('Special', data)
      let arr = [];
      let detailData = [];
      data.forEach(item => {
        let {DetailModels, ProcessModels, ...rest} = item;
        arr.push(rest);
        let o = {
          name: rest.ProductName,
          DetailModels
        }
        detailData.push(o)
      })
      this.tableData = arr;
      this.detailData = detailData;

    },
    productData(pData){
      let data = pData.filter(item => {
          return item.ProcessStage !== 3 && item.ProcessStage !== 4
        })
        this.DAccount = data;
        this.initDAccount = data;
        this.listTotal = data.length;
        this.initTotal = data.length;
    },
    processListProp(val){
      this.processList = val
    }
  },
  data() {
    return {
      tableData: [],
      detailData: [],
      pdApi: require('@/api/ba/product').default,
      propertyApi: require('@/api/ba/property').default,
      teProcessApi: require('@/api/production/teProcess').default,
      processList: [],
      initDAccount:[],
      initTotal:0,
      DAccount: [],
      listTotal:0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      imgs: [],
      currentRow: null,
      craftData: [],
      subTableData: [],
      propertyList: [],
    };
  },
  created(){

    
    // this.pdApi.list({Status: 1}).then(res => {

    //   if(res.Code === 0){
    //     let data = res.Data.filter(item => {
    //       return item.ProcessStage !== 3 && item.ProcessStage !== 4
    //     })
    //     this.DAccount = data;
    //     this.initDAccount = data;
    //     this.listTotal = data.length;
    //     this.initTotal = data.length;
    //   }
      
    // })

    // this.teProcessApi.list({}).then(res => {
    //   if(res.Code === 0){
    //     this.processList = res.Data;

    //   }
    // })

    let propertyList = JSON.parse(localStorage.getItem('propertyList'))
    this.propertyList = propertyList;
    //  this.propertyApi.list({Status: 1}).then(res => {
    //   if(res.Code === 0){
    //     this.propertyList = res.Data;
    //   }
    // })
  },
  methods: {
    
    selectCome(row){
      this.currentRow = row;
      this.$refs.comeListDialog.open();
    },
    comeSelect(row                                                                                                                                                                                                                                                                                                         ){
      this.currentRow.TradeUnitId = row.TradeUnitId;
      this.currentRow.FullName = row.FullName;
    },
    onSelect(e,row){
      console.log('wjSpecial  e========', e)
      row.ColorId = null;
      row.ColorName = e.ColorName;
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductSpec = e.ProductSpec;
      row.ProcessStage = e.ProcessStage;
      row.ProduceTypeName = e.ProduceTypeName;
      row.ProductId = e.ProductId;
      row.Colors = e.Colors
      row.UseProcess = e.UseProcess;
      row.UseColor = e.UseColor;
      row.PdUnitName = e.PdUnitName;
      row.PdUnitId = e.PdUnitId;
      row.Property = null;
    },
    resetFun(){
      this.pageParams.pageIndex=1
      this.DAccount=this.initDAccount
      this.listTotal=this.initTotal
    },
    currentPage(val){
      
      this.pageParams.pageIndex=val
          this.pdApi.list({ Status: 1 }).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal=res.Count
            }
      });
    },
    inputText(text){
       this.pdApi.list({ProductName:text}).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            
            this.listTotal=res.Count
            }
          });
    },
    add() {},
    select() {},
    del() {},
    changeProperty(val, row){

      if(row.T !== 0){
        row.T = 1;
      }
    },
    changeQuantity(val, row){
      if(row.T !== 0){
        row.T = 1
      }
    },
    changeRemarks(val, row){
      if(row.T !== 0){
        row.T = 1
      }
    },
    changeColor(val, row){
      let ids = row.Colors.map(item => {
        return item.ColorId
      })
      let index = ids.indexOf(val);
      let color = row.Colors[index];
      
      row.ColorId = color.ColorId;
      row.ColorName = color.ColorName;
      if(row.T !== 0){
        row.T = 1
      }

    },
    processChange(row){ 
      let id = row.ProcessId;
      let ids = this.processList.map(item => {
        return item.ProcessId
      })
      let index = ids.indexOf(id);
      row.Sn = this.processList[index].Sn;
    },
    base64ToFile(dataurl, filename) {//将base64转换为文件
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg);
      const ImgUrl = res.Data;
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！');
      let imgs = [];
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl));
        // imgs.push(imgBlob);
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs;
      this.$refs.imgDialog.open();
    },
    // viewImg(ImgUrl) {
    //   let imgs = ImgUrl.split(',');
    //   imgs.forEach(item => {
    //     item = urlHttp + item
    //   })

    //   this.imgs = imgs;
    //   this.$refs.imgDialog.open();
    // },
    setSubTableData(arr) {
      // 父组件调用，设置子件列表
      this.subTableData = arr;
    },
    getDetailModels(index, mode = 0) {
      let child = this.subTableData[index].child;

      let DetailModels = [];
      child.forEach((item) => {
        console.log("item", item);

        if(mode === 0){
          if(item.T != null){
            let {
              T,
              ProductId,
              ColorId = 0,
              Property = 0,
              Quantity,
              ProductNo,
              ProductName,
              ProcessStage,
              ProductSpec,
              ColorName,
              TespecialBomId = 0,
              TeProductDetailId = 0,
              TebomId = 0,
              BomType = 1,
              Remarks = "",
            } = item;
            BomType = 1;
            Quantity = Number(Quantity);
            if(Property == null){
              Property = 0;
            }
            ColorId = ColorId ?? 0;

          let o = {
            T,
              ProductId,
              ColorId,
              Property,
              Quantity,
              ProductNo,
              ProductName,
              ProcessStage,
              ProductSpec,
              ColorName,
              TeProductDetailId,
              TebomId,
              BomType,
              TespecialBomId,
              Remarks,
          };

          DetailModels.push(o);
          }
        }else{
          let {
              ProductId,
              ColorId = 0,
              Property = 0,
              Quantity,
              ProductNo,
              ProductName,
              ProcessStage,
              TeProductId = 0,
              ProductSpec,
              ColorName,
              TespecialBomId = 0,
              TeProductDetailId = 0,
              TebomId = 0,
              BomType = 1,
              Remarks = "",
            } = item;
            BomType = 1;
            Quantity = Number(Quantity);
            if(Property == null){
              Property = 0;
            }
            ColorId = ColorId ?? 0;

          let o = {
              ProductId,
              ColorId,
              Property,
              Quantity,
              ProductNo,
              ProductName,
              TeProductId,
              ProcessStage,
              ProductSpec,
              ColorName,
              TeProductDetailId,
              TebomId,
              BomType,
              TespecialBomId,
              Remarks,
          };

          DetailModels.push(o);
        }
          
        
      });

      return DetailModels;
    },
    getSaveData(mode = 0 && mode === 0) {
      let SpecialBomModels = [];
      let bool = true;
      this.tableData.forEach((item, index) => {
        let {
          ProductId,
          ColorId = 0,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          Bomno = "",
          Property = 0,
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId = 0,
          BomType = 1,
          Remarks = "",
          TespecialBomId = 0,
          TeProductId = 0,
        } = item;
        Quantity = Number(Quantity);
        BomType = 1
         if(Property == null){
            Property = 0;
          }
          ColorId = ColorId ?? 0;
     

        let DetailModels = this.getDetailModels(index, mode);
         if(mode === 1 && DetailModels.length === 0){
          bool = false
        }

        let o = {
          DetailModels,
          ProductId,
          ColorId,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId,
          ProgrammeId: 0,
          ProcessModels: null,
          Bomno,
          BomType,
          Remarks,
          TespecialBomId,
          TeProductId,
          Property
        };
        SpecialBomModels.push(o);
      });

      console.log('特殊 BomModels', SpecialBomModels)


      if(bool){
        return SpecialBomModels;
      }else{
        return bool
      }
    },
    copyDetailModels(index) {
      let child = this.subTableData[index].child;

      let DetailModels = [];
      child.forEach((item) => {
        console.log("item", item);

        let {
          T,
          ProductId,
          ColorId,
          Property = 0,
          Quantity,
          ProductNo,
          ProductName,
          ProcessStage,
          ProductSpec,
          ColorName,
          TespecialBomId = 0,
          TeProductDetailId = 0,
          TebomId = 0,
          BomType = 1,
          Remarks = "",
        } = item;
        BomType = 1;
        Quantity = Number(Quantity);
        if(Property == null){
          Property = 0;
        }
        ColorId = ColorId ?? 0;

        let o = {
          T,
            ProductId,
            ColorId,
            Property,
            Quantity,
            ProductNo,
            ProductName,
            ProcessStage,
            ProductSpec,
            ColorName,
            TeProductDetailId,
            TebomId,
            BomType,
            TespecialBomId,
            Remarks,
        };

        DetailModels.push(o);
          
        
      });

      return DetailModels;
    },
    copyData(mode = 0) {
      let SpecialBomModels = [];
      let bool = true;
      this.tableData.forEach((item, index) => {
        let {
          ProductId,
          ColorId,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          Bomno = "",
          Property = 0,
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId = 0,
          BomType = 1,
          Remarks = "",
          TespecialBomId = 0,
          TeProductId = 0,
        } = item;
        Quantity = Number(Quantity);
        BomType = 1
         if(Property == null){
            Property = 0;
          }
          ColorId = ColorId ?? 0;
     

        let DetailModels = this.copyDetailModels(index);
         if(mode === 1 && DetailModels.length === 0){
          bool = false
        }

        let o = {
          DetailModels,
          ProductId,
          ColorId,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId,
          ProgrammeId: 0,
          ProcessModels: null,
          Bomno,
          BomType,
          Remarks,
          TespecialBomId,
          TeProductId,
          Property
        };
        SpecialBomModels.push(o);
      });

      console.log('特殊 BomModels', SpecialBomModels)


      if(bool){
        return SpecialBomModels;
      }else{
        return bool
      }
    },
  },
};
</script>

<style lang="scss" scoped>
 .flex{
  display: flex;
 }
</style>

